<template>
  <li class="block blocknode with-paths">
    <!-- standard module -->
    <div v-if="module.action_type === 'standard'" :id="module.id" 
      :class="{
        stepSuccess: isSuccess(), 
        stepFailure: isFailure(),
        stepWaiting: isWaiting(),
        stepRunning: isRunning(),
        'items-center': true, 
        'justify-between': true, 
        module: true, 
        flex: true 
      }"
    >
      <p class="moduleTitle">
        {{ module.title }}
      </p>
      <div class="moduleLogo">
        <div class="con-vs-avatar large" style="background: #F8F8F8;">
          <div class="con-img vs-avatar--con-img">
            <img  :src="'logo' in module ? module.logo : 'https://clikr-modules.s3.amazonaws.com/default.png'">
          </div>
        </div>
      </div>
      <div class="moduleButtons">
        <div class="flex justify-between items-end flex-no-wrap w-full h-full">
          <div class="flex flex-no-wrap">
            <vs-button v-if="exec_id.length <= 0"
              @click="$emit('openAddModulePopup', module)"
              radius
              color="primary"
              type="filled"
              icon="add"
            />
          </div>
          <div class="flex flex-no-wrap">
            <vs-button v-if="exec_id.length >= 1"
              @click="$emit('openLogPopup', module)"
              radius
              color="dark"
              type="filled"
              icon="code"
              class="ml-4"
            />
            <vs-button v-if="exec_id.length <= 0"
              @click="$emit('openEditPopup', module)"
              radius
              color="warning"
              type="filled"
              icon="edit"
              class="ml-4"
            />
            <vs-button v-if="exec_id.length <= 0"
              @click="$emit('deleteModule', module)"
              radius
              color="danger"
              type="filled"
              icon="delete"
              class="ml-4"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- trigger placeholder -->
    <div @click.stop="$emit('toggleModulesSidebar')" v-if="module.action_type === 'trigger-placeholder'" :id="module.id" class="items-center justify-between trigger-placeholder module flex" :class="{noHover: exec_id.length >= 1}">
      <p class="moduleTitle" v-if="exec_id.length <= 0">
       Click here to add an automated trigger to your Clik
      </p>
      <p class="moduleTitle" v-else>
       START
      </p>
      <div class="moduleButtons" v-if="exec_id.length <= 0">
        <div class="flex justify-between items-end flex-no-wrap w-full h-full">
          <div class="flex flex-no-wrap"></div>
          <div class="flex flex-no-wrap">
            <vs-button
              @click.stop="$emit('openAddModulePopup', module)"
              radius
              color="primary"
              type="filled"
              icon="add"
            />
          </div>
          <div class="flex flex-no-wrap"></div>
        </div>
      </div>
    </div>

    <!-- trigger module -->
    <div v-if="module.action_type === 'trigger'" :id="module.id" :class="`items-center justify-between trigger ${module.title} flex`">
      <p class="moduleTitle">
        {{ module.friendlyName }}
      </p>
      <div class="moduleLogo">
        <div class="con-vs-avatar large" style="background: #F8F8F8;">
          <div class="con-img vs-avatar--con-img">
            <img :src="module.logo">
          </div>
        </div>
      </div>
      <div class="moduleButtons">
        <div class="flex justify-between items-end flex-no-wrap w-full h-full">
          <div class="flex flex-no-wrap">
            <vs-button
              @click="$emit('openAddModulePopup', module)"
              radius
              color="primary"
              type="filled"
              icon="add"
            />
          </div>
          <div class="flex flex-no-wrap">
            <vs-button
              @click="$emit('openEditPopup', module)"
              radius
              color="warning"
              type="filled"
              icon="edit"
              class="ml-4"
            />
            <vs-button
              @click="$emit('deleteModule', module)"
              radius
              color="danger"
              type="filled"
              icon="delete"
              class="ml-4"
            />
          </div>
        </div>
      </div>
    </div>

    <ul v-if="module.children" :id="blockId" :class="`if-branches blocknode-paths ${hasMultiple}`">
      <template v-if="module.children">
        <template v-for="module in module.children">
          <node-tree
            @openAddModulePopup="openAddModulePopup"
            @openLogPopup="openLogPopup"
            @openEditPopup="openEditPopup"
            @deleteModule="deleteModule"
            :module="module"
            :key="module.id"
            :exec_id="exec_id"
          ></node-tree>
        </template>
      </template>
    </ul>
  </li>
</template>

<script>
import nodeTree from './nodeTree.vue'

export default {
  name: 'node-tree',
  components: {
    'node-tree': nodeTree
  },
  props: ['module', 'exec_id'],
  created () {

  },
  computed: {
    blockId () {
      return `block-${this.module.id}`
    },
    hasMultiple () {
      const $this = this
      if ($this.module.children.length >= 2) {
        return 'has-multiple'
      }
    }
  },
  methods: {
    isSuccess () {
      if (this.exec_id.length <= 0) return false
      return this.module && this.module.status === 0
    },
    isFailure () {
      if (this.exec_id.length <= 0) return false
      return this.module && this.module.status === 1
    },
    isWaiting () {
      if (this.exec_id.length <= 0) return false
      return this.module && (this.module.status === -1 || this.module.status === undefined)
    },
    isRunning () {
      if (this.exec_id.length <= 0) return false
      console.log(this.module)
      return this.module && this.module.status === 2
    },
    openAddModulePopup (module) {
      console.log(module)
      const $this = this
      $this.$emit('openAddModulePopup', module)
    },
    openLogPopup (module) {
      const $this = this
      $this.$emit('openLogPopup', module)
    },
    openEditPopup (module) {
      const $this = this
      $this.$emit('openEditPopup', module)
    },
    deleteModule (module) {
      const $this = this
      $this.$emit('deleteModule', module)
    }
  }
}
</script>
